import { FC, HTMLAttributes } from 'react';
import styled from 'styled-components';
import { Icon, IconName, IconSize } from '@ardoq/icons';
import { t, type WithI18nLocale } from '@ardoq/i18n';

export const ExternallyManagedIndicatorWrapper = styled.span`
  display: flex;
  align-items: center;
`;

const ExternallyManagedText = styled.span`
  margin-left: 4px;
  font-size: 14px;
  &:hover {
    text-decoration: underline;
  }
`;

type ExternallyManagedIndicatorProps = HTMLAttributes<HTMLSpanElement> &
  WithI18nLocale;

const ExternallyManagedIndicator: FC<ExternallyManagedIndicatorProps> = ({
  i18nLocale,
  ...props
}) => (
  <ExternallyManagedIndicatorWrapper {...props}>
    <Icon iconName={IconName.EXTERNALLY_MANAGED} iconSize={IconSize.SMALL} />
    <ExternallyManagedText>
      {t(i18nLocale, 'externallyManaged:indicator.label', 'Externally managed')}
    </ExternallyManagedText>
  </ExternallyManagedIndicatorWrapper>
);

export { ExternallyManagedIndicator };
